<template>
  <div>
    <b-card header="광고계정 선택">
      <b-select text-field="name" value-field="id"
                :options="adAccountList" v-model="selectedAdAccountId" @input="adAccountChanged">
        <template slot="first">
          <option :value="null" disabled>광고계정을 선택해주세요</option>
        </template>
      </b-select>
    </b-card>
    <router-view v-bind="selectorProps">

    </router-view>
  </div>
</template>

<script>
  import adMasterApi from "@/common/gap/api/adMasterApi.js";
  import {AUTHORIZATION_PROPERTY} from "../../constants";
  import missionApi from "@/common/gap/api/missionApi";

  export default {
    name: "AdAccountSelector",
    data() {
      return {
        selectedAdAccount: null,
        selectedAdAccountId: null,
        adAccountList: []
      }
    },
    async mounted() {
      await this.loadAdAccountList();
      const missionId = this.$route.params.missionId;
      let campaignId = null;
      let adAccountId = null;
      if (missionId) {  //광고상품 아이디가 있으면 캠페인 아이디 빼와서 자동으로 광고계정 설정
        const {data: {data: {mission: mission}}} = await missionApi.getMission(missionId);
        campaignId = mission.campaignId;
        adAccountId = mission.adAccountId;
      }

      if (campaignId) {
        const {data: {data: campaign}} = await adMasterApi.getCampaign(missionId, adAccountId);
        const {data: {data: adAccount}} = await adMasterApi.getAdAccount(campaign.adAccountId);
        this.adAccountChanged(adAccount.id);
      }
    },
    methods: {
      async loadAdAccountList() {
        let auth = JSON.parse(localStorage.getItem(AUTHORIZATION_PROPERTY));
        let authType = auth.authType;
        if (authType === 'ldap') {
          this.adAccountList = (await adMasterApi.findAllAdAccounts()).data.data;
        } else {//비즈 계정이면 자신이 속한 광고계정만 보여줌
          this.adAccountList = (await adMasterApi.getAdAccountsByUserId(auth.personName)).data.data;
        }
      },
      adAccountChanged(adAccountId) {
        this.selectedAdAccountId = adAccountId;
        this.selectedAdAccount = this.adAccountList.find(elm => elm.id === adAccountId);
      }
    },
    computed: {
      selectorProps() {
        return {
          adAccount: this.selectedAdAccount
        }
      }
    }
  }
</script>

<style>

</style>
